import { Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './Components/Pages/Home/Header/Header';
import Service from './Components/Pages/Home/Service/Service';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './Components/Pages/Home/Home/Home';
import Footer from './Components/Pages/Shared/Footer/Footer';
import Services from './Components/Pages/Home/Header/Services/Services';
import ServiceDetails from './Components/Pages/Home/Header/ServiceDetails/ServiceDetails';
import NotFound from './Components/Pages/Home/NotFound/NotFound';
import Login from './Components/Pages/Home/Login/Login';
import Signup from './Components/Pages/Home/Signup/Signup';
import RequireAuth from './RequireAuth';
import Blogs from './Components/Pages/Home/Blogs/Blogs';
import About from './Components/Pages/Home/About/About';

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/services' element={<Services/>}/>
        <Route path='/blogs' element={<Blogs/>}/>
        <Route path='/about' element={<About/>}/>
        <Route path='/service-details/:id' element={
          <RequireAuth>
        <ServiceDetails/>
        </RequireAuth>
        }/>
        <Route path='/login' element={<Login/>}/>
        <Route path='/signup' element={<Signup/>}/>

        <Route path='*' element={<NotFound/>} />
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
